import { useState } from "react";
import { Star } from "lucide-react";
import { reviewsForProperty } from "@/data/reviews";

function ReviewCard({ r }) {
  const [open, setOpen] = useState(false);
  const isLong = r.fullText.length > r.excerpt.length + 4;
  return (
    <div className="bg-white border border-brand-ivory rounded-2xl p-6" data-testid={`prop-review-${r.id}`}>
      <div className="flex gap-1 mb-3">
        {Array.from({ length: 5 }).map((_, i) => <Star key={i} className={`w-4 h-4 ${i < r.rating ? "fill-brand-gold text-brand-gold" : "text-brand-ivory"}`} />)}
      </div>
      <p className="text-brand-brown leading-relaxed italic">“{open ? r.fullText : r.excerpt}”</p>
      {isLong && <button onClick={() => setOpen((v) => !v)} className="mt-2 text-sm text-brand-olive underline underline-offset-4">{open ? "Riduci" : "Leggi di più"}</button>}
      <div className="mt-4 text-sm"><span className="font-medium text-brand-black">{r.guestName}</span><span className="text-brand-brown"> · {r.stayDate} · {r.language.toUpperCase()}</span></div>
    </div>
  );
}

export default function PropertyReviews({ slug }) {
  const all = reviewsForProperty(slug);
  const [showAll, setShowAll] = useState(false);
  if (!all.length) return null;
  const visible = showAll ? all : all.slice(0, 8);
  return (
    <section className="mt-16">
      <h2 className="font-heading text-3xl text-brand-black mb-2">Le parole dei nostri ospiti</h2>
      <p className="text-sm text-brand-brown/70 mb-6">Recensioni reali trascritte da piattaforme di prenotazione.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {visible.map((r) => <ReviewCard key={r.id} r={r} />)}
      </div>
      {all.length > 8 && (
        <button onClick={() => setShowAll((v) => !v)} data-testid="prop-reviews-toggle" className="mt-6 inline-flex border border-brand-olive text-brand-olive hover:bg-brand-ivory transition-colors rounded-full px-7 py-3 font-medium">
          {showAll ? "Mostra meno" : `Leggi tutte le recensioni (${all.length})`}
        </button>
      )}
    </section>
  );
}
